import { generateViewsComponent } from "../../../../../../../../helpers/views.js";
import PanelAccommodationPersonDesktop from "./views/desktop/index.js";
import PanelAccommodationPersonMobile from "./views/mobile/index.js";
const PanelAccommodationPerson = generateViewsComponent(PanelAccommodationPersonDesktop, PanelAccommodationPersonMobile);
export default PanelAccommodationPerson;

//# sourceMappingURL=index.js.map